// The actions that will be available form the context
enum ACTIONS {
  UPDATE_APP_CONTEXT = 'UPDATE_APP_CONTEXT',
  RESET_APP_CONTEXT = 'RESET_APP_CONTEXT'
}

export default ACTIONS;
